<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <ul
            ngbNav
            #customNav="ngbNav"
            [activeId]="1"
            class="nav-tabs nav-tabs-custom nav-justified">
            <li [ngbNavItem]="1">
              <a ngbNavLink> Registration </a>
              <ng-template ngbNavContent>
                <ng-template [ngTemplateOutlet]="wizard"> </ng-template>
              </ng-template>
            </li>

            <li [ngbNavItem]="2">
              <a ngbNavLink> My Stories </a>
              <ng-template ngbNavContent>
                <ng-template [ngTemplateOutlet]="stories"> </ng-template>
              </ng-template>
            </li>

            <li [ngbNavItem]="3">
              <a ngbNavLink> My Page </a>
              <ng-template ngbNavContent>
                <ng-template [ngTemplateOutlet]="page"> </ng-template>
              </ng-template>
            </li>

            <li [ngbNavItem]="4">
              <a ngbNavLink> Family Tree </a>
              <ng-template ngbNavContent>
                <ng-template [ngTemplateOutlet]="tree"> </ng-template>
              </ng-template>
            </li>

            <li [ngbNavItem]="5">
              <a ngbNavLink> Wish I Was There </a>
              <ng-template ngbNavContent>
                <ng-template [ngTemplateOutlet]="wish"> </ng-template>
              </ng-template>
            </li>
          </ul>

          <div [ngbNavOutlet]="customNav"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #wizard>
  <app-wizard></app-wizard>
</ng-template>

<ng-template #stories>
  <app-my-stories></app-my-stories>
</ng-template>

<ng-template #page>
  <app-my-page></app-my-page>
</ng-template>

<ng-template #tree>
  <app-family-tree></app-family-tree>
</ng-template>

<ng-template #wish>
  <app-wish-there></app-wish-there>
</ng-template>
